import { useState, useEffect } from 'react';

import { Button, Modal, ModalProps, Text, u } from '@ui';

const MODAL_MIN_WIDTH = 640;

type ConfirmActiveModalProps = Pick<ModalProps, 'onDismiss' | 'open'> & {
    onAccept: () => void;
    logoutAt: number | null;
};
export function ConfirmActiveModal({ onAccept, onDismiss, logoutAt, open }: ConfirmActiveModalProps) {
    const [remainingMs, setRemainingMs] = useState<number>(0);

    useEffect(() => {
        if (!logoutAt) {
            setRemainingMs(0);
            return;
        }

        const tick = () => {
            setRemainingMs(Math.max(logoutAt - Date.now(), 0));
        };

        tick();
        const id = window.setInterval(tick, 1000);

        return () => window.clearInterval(id);
    }, [open, logoutAt]);

    const totalSeconds = Math.ceil(remainingMs / 1000);
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;

    return (
        <Modal
            onDismiss={onDismiss}
            open={open}
            title="Are you still there?"
            variant="partial"
            footer={{
                primary: <Button onClick={onDismiss}>Stay logged in</Button>,
                secondary: (
                    <Button variant="destroy" onClick={onAccept}>
                        Log me out
                    </Button>
                ),
            }}
        >
            <Text
                variant="h1"
                fontWeight={600}
                textAlign="center"
                style={{ fontVariantNumeric: 'tabular-nums' }}
                mb={u(1)}
            >
                {minutes.toString().padStart(2, '0')}:{seconds.toString().padStart(2, '0')}
            </Text>
            <Text variant="p" pb={u(2)} style={{ maxWidth: MODAL_MIN_WIDTH }}>
                You have been inactive for a while. You will be logged out automatically once timer reaches zero
            </Text>
        </Modal>
    );
}
